<div class="building-efficiency-results">
  <label class="title">{{ 'module.shared.buildingEfficiencyWizard.step4.titleText' | translate }} {{ data?.buildingEfficiencyData.buildingTypeName }}</label
  ><br />
  <div class="sub-title">
    <span class="period-text">{{ 'module.shared.buildingEfficiencyWizard.step4.periodText' | translate }}</span>
    <span class="period">{{ startDate }} - {{ endDate }}</span>
  </div>

  <div class="body-section">
    <div class="left-side">
      <div class="electricity">
        <table class="table" aria-describedby="efficiency-analysis">
          <tr class="header-text">
            <td class="icon">
              <app-svg-icon alt="energy-type-img" [src]="strom"></app-svg-icon>
            </td>
            <td class="title">STROM</td>
            <td>
              <div class="bar"></div>
            </td>
            <td class="color">
              <div class="green" *ngIf="electricityColorStatus === 'green'">
                {{ 'module.shared.buildingEfficiencyWizard.step4.efficientText' | translate }}
              </div>
              <div class="yellow" *ngIf="electricityColorStatus === 'yellow'">
                {{ 'module.shared.buildingEfficiencyWizard.step4.midEfficientText' | translate }}
              </div>
              <div class="red" *ngIf="electricityColorStatus === 'red'">
                {{ 'module.shared.buildingEfficiencyWizard.step4.inefficientText' | translate }}
              </div>
            </td>
            <td class="error" *ngIf="electricityColorStatus === 'red'">
              <div
                class="error-message"
                id="chart1-error"
                *ngIf="data.buildingEfficiencyData.electricityComputedValue > data?.buildingEfficiencyData.electricityMaxDataRange"
              >
                {{ 'module.shared.buildingEfficiencyWizard.step4.electricityErrorMessage' | translate }}
              </div>
            </td>
          </tr>
          <tr>
            <app-line-gauge-chart-tri-color
              [dataRange]="electricityDataRange"
              [data]="electricityData"
              [chartName]="stromChartName"
            ></app-line-gauge-chart-tri-color>
          </tr>
        </table>
      </div>
      <div class="heat">
        <table class="table" aria-describedby="efficiency-analysis">
          <tr class="header-text">
            <td class="icon">
              <app-svg-icon [src]="warme"></app-svg-icon>
            </td>
            <td class="title">WÄRME</td>
            <td>
              <div class="bar"></div>
            </td>
            <td class="color">
              <div class="green" *ngIf="heatColorStatus === 'green'">
                {{ 'module.shared.buildingEfficiencyWizard.step4.efficientText' | translate }}
              </div>
              <div class="yellow" *ngIf="heatColorStatus === 'yellow'">
                {{ 'module.shared.buildingEfficiencyWizard.step4.midEfficientText' | translate }}
              </div>
              <div class="red" *ngIf="heatColorStatus === 'red'">
                {{ 'module.shared.buildingEfficiencyWizard.step4.inefficientText' | translate }}
              </div>
            </td>
            <td class="error" *ngIf="heatColorStatus === 'red'">
              <div
                class="error-message"
                id="chart1-error"
                *ngIf="data.buildingEfficiencyData.heatComputedValue > data?.buildingEfficiencyData.heatMaxDataRange"
              >
                {{ 'module.shared.buildingEfficiencyWizard.step4.heatErrorMessage' | translate }}
              </div>
            </td>
          </tr>
          <tr>
            <app-line-gauge-chart-tri-color [dataRange]="heatDataRange" [data]="heatData" [chartName]="warmeChartName"> </app-line-gauge-chart-tri-color>
          </tr>
        </table>
      </div>
    </div>
    <div class="right-side">
      <div class="legend">
        <table class="reference-values" aria-describedby="building-efficiency">
          <tr>
            <th scope="col" class="legend-header row1">
              {{ 'module.shared.buildingEfficiencyWizard.step4.indicatorHeaderText' | translate }}
            </th>
            <th scope="col" class="legend-header label">
              <div class="unit-header">
                <div>
                  {{ 'module.shared.buildingEfficiencyWizard.step4.electricityText' | translate }}
                </div>
                <div class="unit">
                  {{ 'module.shared.buildingEfficiencyWizard.step4.unitLabelText' | translate }}
                </div>
              </div>
            </th>
            <th scope="col" class="legend-header row3">
              <div class="unit-header">
                <div class="warme-header">
                  <span>{{ 'module.shared.buildingEfficiencyWizard.step4.heatText' | translate }}</span>
                  <img
                    class="cloud-sun-rain"
                    alt="marker-img"
                    src="./assets/icons/cloud-sun-rain-solid.svg"
                    matTooltip="{{ 'module.shared.buildingEfficiencyWizard.step4.tooltipText' | translate }}"
                    [matTooltipPosition]="'above'"
                    matTooltipClass="matTooltip-building-efficiency-results"
                  />
                </div>
                <div class="unit">
                  {{ 'module.shared.buildingEfficiencyWizard.step4.unitLabelText' | translate }}
                </div>
              </div>
            </th>
          </tr>
          <tr>
            <td class="efficiency-indicator">
              <div class="primary-icon">
                <app-svg-icon alt="energy-type-img" [src]="marker"></app-svg-icon>
              </div>
              <div class="legend-description">
                <h5>
                  {{ 'module.shared.buildingEfficiencyWizard.step4.description1Text' | translate }}
                </h5>
              </div>
            </td>
            <td
              class="legend-value computed row2"
              [ngClass]="{
                'row2-red': electricityData[2].value > data?.buildingEfficiencyData.electricityMaxDataRange,
                'row2-gray': electricityData[2].value <= data?.buildingEfficiencyData.electricityMaxDataRange
              }"
            >
              {{ getLocalNumber(electricityData[2].value) }}
            </td>
            <td
              class="legend-value computed row3"
              [ngClass]="{
                'row2-red': heatData[2].value > data?.buildingEfficiencyData.heatMaxDataRange,
                'row2-gray': heatData[2].value <= data?.buildingEfficiencyData.heatMaxDataRange
              }"
            >
              {{ getLocalNumber(heatData[2].value) }}
            </td>
          </tr>
          <tr>
            <td class="efficiency-indicator">
              <div>
                <img class="icon" alt="lightgrey-arrow-img" src="./assets/icons/indicator-average.svg" />
              </div>
              <div class="legend-description">
                <h5>
                  {{ 'module.shared.buildingEfficiencyWizard.step4.description2Text' | translate }}
                </h5>
              </div>
            </td>
            <td class="legend-value row2">{{ electricityData[0].value }}</td>
            <td class="legend-value">{{ heatData[0].value }}</td>
          </tr>
          <tr>
            <td class="efficiency-indicator">
              <div>
                <img class="icon" alt="darkgrey-arrow-img" src="./assets/icons/indicator-standard-guide.svg" />
              </div>
              <div class="legend-description">
                <h5>
                  {{ 'module.shared.buildingEfficiencyWizard.step4.description3Text' | translate }}
                </h5>
              </div>
            </td>
            <td class="legend-value row2">{{ electricityData[1].value }}</td>
            <td class="legend-value">{{ heatData[1].value }}</td>
          </tr>
        </table>
      </div>
      <div class="notes">
        <div class="note-label">
          {{ 'module.shared.buildingEfficiencyWizard.step4.noticeText' | translate }}
        </div>
        <div class="textarea">
          <mat-form-field class="mat-text-area">
            <textarea
              title="notes"
              [disabled]="!isEditable || !authService.isAdminAreaAndMunicipalityWorker"
              [(ngModel)]="notes"
              matInput
              (ngModelChange)="notesChange()"
              [maxLength]="noteLimit"
              class="note-text-area"
              cdkTextareaAutosize
              #autosize="cdkTextareaAutosize"
              cdkAutosizeMinRows="5"
              cdkAutosizeMaxRows="10"
              >{{ notes }}</textarea
            >
          </mat-form-field>
          <p *ngIf="isEditable && authService.isAdminAreaAndMunicipalityWorker" class="note-limit-indicator">
            {{ notes === null ? '0/' + noteLimit : notes.length + '/' + noteLimit }}
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
